/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import FormElementBase from '../FormElementBase';
import FieldEditor from './TextInputElement/TextInputElementFieldEditorView';
import FormView from './TextInputElement/TextInputElementFormView';
import EditView from './TextInputElement/TextInputElementEditView';

import IndexedList from '../../../support/shared/IndexedList';
import { Icon } from '../../uiold';
import { themeColors } from '../../uiold/Constants';
import parseTextForLinks from '../helpers/parseTextForLinks';
import { FormFieldDefinition } from '../../../types/shared/FormFieldDefinition';
import { Market } from '../../../types/shared/Market';
import { Field } from '../../../types/shared/Vendor';

type ReadOnlyViewProps = {
  isAdmin: boolean;
  value: string | null | undefined;
  // onFileClick: (file: FileDesc, event: Event) => void;
  isLoading: boolean;
  markets: IndexedList<Market>;
  fields: IndexedList<Field>;
};

type FormViewProps = {
  onChange?: (id: string, value: string) => void;
};

type EditViewProps = {
  value: string;
  onChange: (id: string, value: string) => void;
};

class TextInputElement extends FormElementBase {
  static getType() {
    return 'TextElement';
  }

  static getDescription() {
    return 'Text Input';
  }

  static getAttributes() {
    return {
      name: 'Text Input',
      label: 'Text Input',
      placeholder: null,
      multiline: false,
      hidden: false,
      is_required: false,
      is_public: false,
      auto_linking: false,
      field_validation: null,
    };
  }

  static getIconName() {
    return 'textInput';
  }

  static getIcon() {
    return <Icon name="textInput" size="M" />;
  }

  renderFieldEditor() {
    return <FieldEditor key={this.id} ref="field-editor" parent={this} />;
  }

  renderFieldView() {
    return (
      <FormView
        key={this.id}
        ref={this.id}
        definition={this.definition as FormFieldDefinition}
        readOnly={true}
      />
    );
  }

  renderFormView(props?: FormViewProps) {
    props = props || {};
    return (
      <FormView
        key={this.id}
        ref={this.id}
        definition={this.definition as FormFieldDefinition}
        {...props}
      />
    );
  }

  renderReadOnlyView(props: ReadOnlyViewProps) {
    let { value } = props;
    if (this.definition.auto_linking) {
      let parsedText = parseTextForLinks(value);
      let segments = parsedText.map((parsedElement, key) => {
        if (parsedElement.url) {
          return (
            <a
              key={key}
              href={parsedElement.url}
              target="_blank"
              rel="noreferrer"
              style={{ color: themeColors.blue, textDecoration: 'underline' }}
            >
              {parsedElement.text}
            </a>
          );
        }
        return <span key={key}>{parsedElement.text}</span>;
      });
      return <span>{segments}</span>;
    }
    return <span className="text-input">{value}</span>;
  }

  renderEditView(props: EditViewProps) {
    return (
      <EditView
        key={this.id}
        ref={this.id}
        definition={this.definition as any}
        {...props}
      />
    );
  }
}

export default TextInputElement;
